import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import PersonalizationTab from '../components/profile/PersonalizationTab';
import ProgressTab from '../components/profile/ProgressTab';
import { useNavigate } from 'react-router-dom';

const { FiUser, FiTrendingUp } = FiIcons;

const Profile = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState('personalization');

	useEffect(() => {
		if (!user) {
			navigate('/signin', { replace: true });
		}
	}, [user, navigate]);

	const tabs = [
		{ id: 'personalization', name: 'My Personalization', icon: FiUser },
		{ id: 'progress', name: 'My Progress', icon: FiTrendingUp }
	];

	return (
		<div className="min-h-screen py-2">
			<div className="max-w-6xl mx-auto">
				{/* Header */}
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					animate={{ opacity: 1, y: 0 }}
					className="text-center mb-2"
				>
					<div className="w-20 h-20 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-2">
						<span className="text-2xl font-bold text-white">
							{user.name?.charAt(0).toUpperCase() || 'U'}
						</span>
					</div>
					<h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-1">
						{user.name}
					</h1>
					<p className="text-gray-600 dark:text-gray-300">
						{user.email}
					</p>
				</motion.div>

				{/* Tabs */}
				<div className="mb-4">
					<div className="flex space-x-1 bg-gray-100 dark:bg-gray-800 p-1 rounded-lg">
						{tabs.map((tab) => (
							<button
								key={tab.id}
								onClick={() => setActiveTab(tab.id)}
								className={`flex-1 flex items-center justify-center space-x-2 px-4 py-2 rounded-md font-medium transition-colors ${activeTab === tab.id
									? 'bg-white dark:bg-gray-700 text-emerald-600 shadow-sm'
									: 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
									}`}
							>
								<SafeIcon icon={tab.icon} className="w-4 h-4" />
								<span className="hidden sm:inline">{tab.name}</span>
							</button>
						))}
					</div>
				</div>

				{/* Tab Content */}
				<motion.div
					key={activeTab}
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.3 }}
				>
					{activeTab === 'personalization' && <PersonalizationTab />}
					{activeTab === 'progress' && <ProgressTab />}
				</motion.div>
			</div>
		</div>
	);
};

export default Profile;